import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { constants } from "@qgiv/core-js";
import ShippingAddress from "../../common/ShippingAddress";
import { selectAllProductSettings } from "../../../redux/slices/productSettingsSlice";
import { selectCmsControlByIdByPage } from "../../../redux/slices/cmsSettingsSlice";

const ConnectedShippingAddress = ({ controlId }) => {
    const {
        ENUMS: { DefaultView },
    } = constants;

    const { offerShipping = false, requirePhone = false } = useSelector(
        selectAllProductSettings,
    );

    const control = useSelector((state) =>
        selectCmsControlByIdByPage(
            controlId,
            DefaultView.REGISTRATION_CHECKOUT_STEP,
            state,
        ),
    );

    const {
        options: { additionalText, shipToAddressCheckboxLabel, sectionHeading },
    } = control;

    const displayShippingAddress = offerShipping;

    const shippingAddressProps = {
        controlId,
        additionalText,
        displayShippingAddress,
        requirePhone,
        sectionHeading,
        shipToAddressCheckboxLabel,
    };
    return <ShippingAddress {...shippingAddressProps} />;
};

ConnectedShippingAddress.propTypes = {
    controlId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
        .isRequired,
};

export default ConnectedShippingAddress;
